import { get, post } from '../../../Services/http';
import { catchError } from '../../../Actions/Error.action';
import { toggleSpinnerLoader } from '../../../_PandoNexis/Actions/GenericLoader.action';

import {
  NEWSLETTER_SIGNUP_LOAD,
  NEWSLETTER_SIGNUP_MESSAGE,
  NEWSLETTER_SIGNUP_ERROR,
} from '../constants';

const rootRoute = '/api/pandoNexis/newsletter/';

export const getSignupPageData = () => (dispatch, getState) => {
  return get(rootRoute + `loadContent`)
    .then((response) => response.json())
    .then((response) => dispatch(setSignupPageData(response)))
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const signup = (email, placement = 'block', voucherCode = '') => (dispatch, getState) => {
  toggleSpinnerLoader(true);
  const data = {
    email,
    sendEmail: true,
    voucherCode: '',
    placement
  };
    
  return post(rootRoute + `addsubscriber`, data)
    .then((response) => response.json())
    .then((response) => dispatch(emailSentMessage(response)))
    .catch((ex) => {
      dispatch(
        catchError(ex, (error) => {
          loadError(error);
        })
      );
      emailSentErrorMessage('Error');
    });
};

export const loadError = (error) => (dispatch, getState) => {
  toggleSpinnerLoader(false);
  return dispatch({
    type: NEWSLETTER_SIGNUP_ERROR,
    payload: {
      error,
      status: 'error',
    },
  });
};

export const setSignupPageData = (response) => (dispatch) => {
  toggleSpinnerLoader(false);
  return dispatch({
    type: NEWSLETTER_SIGNUP_LOAD,
    payload: {
      newsletterSignupData: response?.result,
      status: 'loaded',
    },
  });
};

export const emailSentMessage = () => (dispatch) => {
  toggleSpinnerLoader(false);
  return dispatch({
    type: NEWSLETTER_SIGNUP_MESSAGE,
    payload: {
      showSignupMessage: true,
      status: 'sent',
    },
  });
};
export const emailSentErrorMessage = () => (dispatch) => {
  toggleSpinnerLoader(false);

  return dispatch({
    type: NEWSLETTER_SIGNUP_MESSAGE,
    payload: {
      showSignupMessage: true,
      status: 'error',
    },
  });
};
